import constants from 'app-constants';
import logger from '../logging';
import { Config } from './main';

import { version } from '../../package.json';

const appLogger = logger('lib-ui-feature-flags');
export const config: Config = {
  log: appLogger,
  appId: 'ui-eligibility-portal',
  appVersion: version,
  clientId: constants.launchDarklyClientId,
  onFlagsChange: () => () => {
    return;
  },
  defaults: {},
};
